"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSelectValues;
var React = _interopRequireWildcard(require("react"));
var _valueUtil = require("../utils/valueUtil");
var _strategyUtil = require("../utils/strategyUtil");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** Return  */
function useSelectValues(rawValues, _ref) {
  var value = _ref.value,
    getEntityByValue = _ref.getEntityByValue,
    getEntityByKey = _ref.getEntityByKey,
    treeConduction = _ref.treeConduction,
    showCheckedStrategy = _ref.showCheckedStrategy,
    conductKeyEntities = _ref.conductKeyEntities,
    getLabelProp = _ref.getLabelProp;
  return React.useMemo(function () {
    var mergedRawValues = rawValues;
    if (treeConduction) {
      var rawKeys = (0, _strategyUtil.formatStrategyKeys)(rawValues.map(function (val) {
        var entity = getEntityByValue(val);
        return entity ? entity.key : val;
      }), showCheckedStrategy, conductKeyEntities);
      mergedRawValues = rawKeys.map(function (key) {
        var entity = getEntityByKey(key);
        return entity ? entity.data.value : key;
      });
    }
    return (0, _valueUtil.getRawValueLabeled)(mergedRawValues, value, getEntityByValue, getLabelProp);
  }, [rawValues, value, treeConduction, showCheckedStrategy, getEntityByValue]);
}